export default __webpack_public_path__ + "static/media/exampleImage3.587c59c7.jpg";